module.exports = __webpack_public_path__ + "img/admin-feature-estimateoption.ebfc74f8.png";